
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/companies/[shortname]",
      function () {
        return require("private-next-pages/companies/[shortname].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/companies/[shortname]"])
      });
    }
  